import { Combobox } from "components/DesignSystem/Combobox/Combobox";
import { TextArea } from "components/DesignSystem/TextArea/TextArea";
import Input from "components/DesignSystem/Input/Input";
import { useMemo } from "react";
import { components, GroupHeadingProps } from "react-select";
import { useGetTagsForCategoryQuery } from "store/apis/billing";
import { useGetCountriesDataQuery } from "store/apis/onboarding";
import { getGroupedCountryOptionsByUuid } from "utils/stateRequired";

const GroupHeading = <T,>(props: GroupHeadingProps<T>) => (
  <components.GroupHeading
    {...props}
    className="t-text-neutral-40 t-text-body-sm t-font-light t-pl-3 t-pr-3 t-pb-1 t-pt-3"
  />
);

export const PracticeDetailsFields = () => {
  const { data: countries } = useGetCountriesDataQuery();
  const { data: tagsData = [] } = useGetTagsForCategoryQuery({
    tagType: "SERVICE_TEAM_TAG",
  });

  const countryOptions = useMemo(
    () => getGroupedCountryOptionsByUuid(countries),
    [countries]
  );

  const serviceOptions = tagsData.map(({ uuid, title }) => ({
    label: title,
    value: uuid,
  }));

  return (
    <div className="t-flex t-flex-col t-gap-4">
      <Input
        withForm
        label="Organisation legal name"
        name="name"
        placeholder="Eg. Acme Accounting LLP"
        required
      />
      <Combobox
        required
        withForm
        label="Country of registration"
        placeholder="Select Country"
        components={{ GroupHeading }}
        options={countryOptions}
        name="country"
      />
      <Combobox
        required
        withForm
        isMulti
        label="Services provided"
        placeholder="Select the Services"
        options={serviceOptions}
        name="tag_ids"
      />
      <TextArea
        label="Any specific requirements from Inkle"
        name="requirements"
      />
    </div>
  );
};
